{
	"home": {
		"anomalies": {
			"empty": "No open anomaly",
			"kind": {
				"email_bounced": "Bounced email",
				"offer_bounced": "Offer not delivered",
				"offer_not_sent": "Offer not sent",
				"ranking_failed": "Calculation failed",
				"transmission_not_delivered": "Application not delivered"
			},
			"no_residence": "No residence",
			"open_all": "Go to sendings",
			"opened": "opened on {{date}}",
			"protocol": "prot. {{protocol}}",
			"title": "Open anomalies",
			"total_one": "{{count}} open anomaly",
			"total_other": "{{count}} open anomalies"
		},
		"calls": {
			"applications_one": "{{count}} valid application",
			"applications_other": "{{count}} valid applications",
			"closed_on": "Closed on {{date}}",
			"closes": "Closes on {{date}}",
			"empty": "No residence has a call yet",
			"intake_open": "Intake of the direct applications open",
			"monitoring": "Go to the monitoring of the calls",
			"no_date": "Dates to be set",
			"offers": "Offers waiting: {{waiting}} · accepted: {{accepted}}",
			"offers_overdue": "Past the term of the manager: {{count}}",
			"open_flags_one": "{{count}} open flag",
			"open_flags_other": "{{count}} open flags",
			"title": "Calls"
		},
		"dsu_quota": {
			"figures": "{{seats}} seats at the DSU rate, threshold {{threshold}}",
			"missing_one": "{{count}} seat missing",
			"missing_other": "{{count}} seats missing",
			"title": "DSU quota below threshold"
		},
		"page_title": "Dashboard",
		"requests": {
			"empty": "No open request",
			"no_name": "Name not given",
			"open_all": "Go to support",
			"opened": "opened on {{date}}",
			"title": "Open support requests",
			"total_one": "{{count}} open request",
			"total_other": "{{count}} open requests"
		}
	},
	"profile": {},
	"ranking_status": {
		"control": "In control, version {{number}}",
		"final": "Final, version {{number}}",
		"page_disabled": "Page disabled",
		"published_review": "Published, version {{number}}"
	},
	"sending_counters": {
		"acknowledged_one": "{{count}} seen",
		"acknowledged_other": "{{count}} seen",
		"awaiting_one": "{{count}} to see",
		"awaiting_other": "{{count}} to see",
		"delivered_one": "{{count}} delivered",
		"delivered_other": "{{count}} delivered",
		"none": "No application sent",
		"not_delivered_one": "{{count}} not delivered",
		"not_delivered_other": "{{count}} not delivered",
		"problem_one": "{{count}} with a problem",
		"problem_other": "{{count}} with a problem",
		"sent_one": "{{count}} sent",
		"sent_other": "{{count}} sent"
	}
}
